import { loadLocaleMessages } from "@/i18n";
import message from "@/features/menu/i18n/messages";

export const load = () => loadLocaleMessages(message);
